import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  margin-bottom: 80px;
  color: #161d1f;

  .title {
    font-family: Lato;
    font-size: 24px;
    font-weight: 900;
    line-height: 32px;
    text-align: left;
    padding: 16px 0px 24px 0px;
    gap: 32px;
    color: #161d1f;
  }
  .signature-states {
    font-family: Lato;
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    text-align: left;
    margin-bottom: 8px;
    margin-right: 16px;
  }
  .states {
    margin-bottom: 24px;
  }
  .legend-group {
    display: flex;
    margin-bottom: 4px;
  }
  .legend {
    display: flex;
    margin-right: 8px;
  }
  .legend .icon {
    margin-right: 8px;
  }
  .legend-icon {
    margin-bottom: 4px;
  }
  .icon {
    display: block;
    width: 24px;
    height: 24px;
    padding: 4px 0px 0px 0px;
    border-radius: 4px;

    font-family: Lato;
    font-size: 12px;
    font-weight: 700;
    line-height: 16px;
    text-align: center;
    &.approved {
      color: #a8f1bb;
      background: #005c27;
    }

    &.validated {
      color: #ffffff;
      background: #007b77;
    }

    &.inProgress {
      color: #fddc70;
      background: #694900;
    }

    &.pending {
      color: #ffffff;
      background: #8090bb;
    }

    &.required {
      border-radius: 100px;
      background: #0285c8;
    }

    &.elective {
      border-radius: 100px;
      background: #283044;
    }
  }
  .card-legend {
    .required {
      margin-left: 4px;
    }
    .elective {
      margin-left: 4px;
    }
  }
  .medium {
    width: 100%;
    padding: 10px 24px 10px 16px;
    gap: 8px;
    border-radius: 4px;
    border: 1px solid #5b36f2;
    font-family: Lato;
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    text-align: center;
    color: #5b36f2;
    background: #ffffff;
    .text-icon {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
    }
  }
  .default-hierarchy {
    margin-bottom: 24px;
  }
  .optional-button {
    display: flex;
    justify-content: flex-end;
    gap: 16px;
  }
  .cycle {
    flex: 1;
  }
  .cycle-3 {
    flex: 0.33;
  }
  .cycle-4 {
    flex: 0.25;
  }
  .cycle-card {
    padding: 8px;
    gap: 8px;
    border-radius: 4px;
    box-shadow: 0px 1.2px 4px 0px #eaeef1;
    background: #ffffff;
    font-family: Lato;
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    text-align: center;
    margin-bottom: 16px;
  }
  .cycle-card-title {
    font-size: 18px;
    margin-bottom: 2px;
  }
  .cycle-card-subtitle {
    width: Fill (248px) px;
    height: Hug (24px) px;
    padding: 4px;
    gap: 10px;
    border-radius: 8px;
    opacity: 0px;
    background: #d5e5f0;
    font-size: 14px;
  }
  .course-card {
    padding: 8px;
    gap: 8px;
    border-radius: 4px;
    box-shadow: 0px 1.2px 4px 0px #eaeef1;
    background: #ffffff;
    font-family: Lato;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    margin-bottom: 8px;
    text-align: left;
  }
  .navigation {
    margin-bottom: 16px;
  }
  .card-legend {
    width: 100%;
  }
  .card-content {
    display: flex;
    justify-content: space-between;
    gap: 8px;
  }
  .legend-content-text {
    color: #4f6168;
    margin-bottom: 2px;
  }
  .legend-content-text-2 {
    margin-bottom: 8px;
    color: #4f6168;
  }
  .legend-content-text-3 {
    margin-bottom: 8px;
    color: #4f6168;
  }
  .prerequisite {
    // margin-bottom: 8px;
    color: #4f6168;
    // margin-left: 8px;
    font-size: 14px;
  }
  .show-prerequisite-button {
    text-align: right;
    margin-top: 8px;
    margin-bottom: 8px;
    margin-right: 8px;
    display: flex;
    justify-content: flex-start;
  }
  .prerequisite-text {
    color: #4f6168;
    font-size: 14px;
  }
  .legend-text {
    .divider {
      height: 1px;
      gap: 0px;
      opacity: 0px;
      background: #7a959f;
    }
  }

  .legend-title {
    //styleName: Body/Body 01 - Bold;
    font-family: Lato;
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    text-align: left;
    margin-bottom: 8px;
    color: #161d1f;
  }
  .legend-content {
    width: Fill (268px) px;
    height: Hug (48px) px;
    padding: 4px 8px 0px 0px;
    gap: 8px;
    opacity: 0px;

    //styleName: Body/Body 02 - Regular;
    font-family: Lato;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    text-align: left;
  }
  .code-course {
    margin-bottom: 8px;
  }
  .card-button * {
    cursor: pointer;
    color: #5b36f2;
    margin: 8px;
    margin-bottom: 0px;
  }
  .content {
    display: grid;
    grid-template-columns: 1fr;
  }
  .extra-info {
  }
  .extra-info li,
  .prerequisite li {
    margin-left: 34px;
    text-indent: -23px;
    color: #4f6168;
    font-size: 14px;
  }
  .course-card.selected {
    border: 1px solid #5b36f2;
    box-shadow: 0px 8px 32px -16px #b0c0ca;
  }

  .course-card.disabled {
    opacity: 0.2;
    pointer-events: none;
  }
  .button.sc-cc-button:focus {
    background-color: white;
  }
  .buttons-cv {
    display: flex;
    justify-content: space-between;
    margin-top: 4px;
  }
  .curriculum-downloader {
    margin-right: 16px;
  }
  .curriculum-downloader-options {
    position: absolute;
    background-color: white;
    border: 1px solid #ccc;
    list-style: none;
    padding: 0;
    margin: 5px 0 0;
    z-index: 10;
    width: 200px;
    box-shadow: 0px 5px 8px 0px #4a4a4a38;
    width: Fixed (211px) px;
    border-radius: 4px;
    opacity: 0px;
  }
  .curriculum-downloader-options .curriculum-downloader-li {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    text-align: left;
    padding: 10px 16px;
    width: 211px;
    height: 40px;
    gap: 0px;
    opacity: 0px;
    display: block;
  }

  .curriculum-downloader-options li:hover {
    background-color: #d5e5f0;
  }
  curriculum-downloader-options li:focus {
    background-color: #a8cbe2;
  }
  curriculum-downloader-options li:active {
    background-color: #e2dffd;
  }

  .curriculum-downloader-options a {
    color: #333; /* Gris oscuro para los enlaces */
    text-decoration: none;
  }
  .loadingName {
    font-weight: 500;
  }
  .alert-info-courses {
    width: Fill (328px) px;
    height: Hug (112px) px;
    padding: 0px 16px 0px 16px;
    gap: 16px;
    border-radius: 8px;
    opacity: 0px;
    background: #d5e5f0;
    display: flex;
    color: #161d1f;
    .alert-info-courses-icon {
      margin-top: 8px;

      margin-right: 8px;
      img {
        width: 16px;
        height: 16px;
        max-width: none;
      }
    }
    ul {
      margin-top: 8px;
      margin-bottom: 8px;
      li {
        list-style: disc;
      }
    }
    margin-bottom: 12px;
  }

  .empty-data-container {
    display: flex;
    margin-top: 204px;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    text-align: center;
    .image {
      width: 80px;
      margin-right: 24px;
    }
    .text {
      font-family: Lato;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      text-align: left;
      color: #161d1f;
    }
  }

  @media (min-width: 640px) {
    .content {
      grid-template-columns: 1fr 1fr;
      gap: 16px;
    }
    .curriculum-downloader {
      margin-right: 24px;
    }
  }

  @media (min-width: 992px) {
    .content {
      grid-template-columns: 1fr 1fr 1fr;
      gap: 24px;
    }
  }

  @media (min-width: 1280px) {
    .content {
      grid-template-columns: 1fr 1fr 1fr 1fr;
    }
    .navigation {
      display: flex;
      justify-content: space-between;
    }
  }

  @media (min-width: 640px) {
    .legend-group-640 {
      display: flex;
    }
    .buttons-cv {
      float: right;
    }
    .default-hierarchy {
      width: 234px;
    }
    .legend-big-group {
      display: block;
    }
  }
  @media (min-width: 768px) {
    .legend-big-group {
      display: flex;
    }
  }

  .custom-button {
    display: inline-flex;
    align-items: center;
    border: 1px solid #6c42f4;
    border-radius: 4px;
    background-color: white;
    color: #6c42f4;
    font-size: 14px;
    cursor: pointer;
    text-decoration: none;
    white-space: nowrap;
    font-weight: 700;
    height: 44px;
  }

  .custom-button .text {
    margin-right: 12px;
    margin-left: 12px;
  }

  .custom-button .divider {
    height: 44px;
    width: 1px;
    background-color: #6c42f4;
  }

  .custom-button .icon {
    margin: 5px;
  }

  .curriculum-downloader-options {
    display: flex;
    flex-direction: column;
  }
`;
export const ButtonPrerequisites = styled.button`
  width: Fill (156px) px;
  height: Hug (32px) px;
  padding: 8px 24px 8px 16px;
  gap: 10px;
  border-radius: 4px;
  opacity: 0px;

  background: #ffffff;

  border: 1px solid #5b36f2;

  color: #5b36f2;
  font-family: Lato;
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

  display: flex;
  align-items: center;
  gap: 4px;
`;
